import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C12.3788 2 12.725 2.214 12.8944 2.55279L21.8944 20.5528C22.067 20.8978 22.0256 21.3113 21.7882 21.6154C21.5508 21.9195 21.1597 22.0599 20.7831 21.9762L12 20.0244L3.21694 21.9762C2.84035 22.0599 2.44921 21.9195 2.2118 21.6154C1.97439 21.3113 1.93306 20.8978 2.10558 20.5528L11.1056 2.55279C11.275 2.214 11.6212 2 12 2ZM13 18.1978L19.166 19.568L12 5.23607L4.83402 19.568L11 18.1978V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V18.1978Z"
    />
  </svg>
);

const PaperAirplaneIcon = (props) => <Icon component={SVG} {...props} />;

export default PaperAirplaneIcon;
